import axios from "axios";

const API_URL  = process.env.REACT_APP_LOGINURL+'signup_forms';//process.env.REACT_APP_BASEURL;
const storeduser = JSON.parse(localStorage.getItem("user"));

const headers = { 
  'Content-Type': 'application/json',
  //'token': localStorage.getItem("session-id")
}

const getAll = (sessionID,filter) => {
  var payload = {
    functionName: "GetCollectionData",
    "postData":{
        "collection_name": "user_forms",
        "filter":filter
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(API_URL, payload, {headers});
};

const get_collection_data = (sessionID,postData) => {
  var payload = {
    functionName: "GetCollectionData",
    "postData":postData
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(API_URL, payload, {headers});
};

const deleteEntity = (sessionID,id,collection_name) => {
  var payload = {
    functionName: "DeleteUserForm",
    postData: {
      "_id": id,
      "collection_name":collection_name,
      "login_user_id": storeduser._id
    },
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(API_URL, payload, {headers});
};


const addEntity = (sessionID,payload) => {
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  //iph todo: 47
  //console.log("Received addEntity Payload:-", payload)
  return axios.post(API_URL, payload, {headers});
}


const UpdateEntity = (sessionID,payload) => {
  //iph todo: 47
  //console.log("Received addEntity Payload:-", payload)
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(API_URL, payload, {headers});
}

const fetchcollections = (sessionID) => {
  var payload = {
    functionName: "FetchCollections",
    postData: {},
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(API_URL, payload, {headers});
}

const get_signiup_data = (id) => {
  var payload = {
    functionName: "GetUserForm",
    postData: {name:id},
  }
  
  return axios.post(API_URL, payload, {headers});
}



const save_user = (payload) => {
  
  const API_URL2  = process.env.REACT_APP_LOGINURL+'signup_forms_insert';
  return axios.post(API_URL2, payload, {headers});
}

const getoptions = (referal_name,filter,fieldlist,limit,offset) => {
  var payload = {
    functionName: "GetCollectionData",
    postData: {
      "collection_name":referal_name,
      "fieldlist":fieldlist,
      "filter":filter,
      "limit":limit,
      "offset":offset
    },
  }
  return axios.post(API_URL, payload, {headers});
};


const UserForms =  {
  getAll,
  deleteEntity,
  addEntity,
  UpdateEntity,
  fetchcollections,
  get_signiup_data,
  save_user,
  get_collection_data,
  getoptions
}

export default UserForms;
